<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Security Gatepass" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="">
             
             <!-- start--------------------------------------------------------------------------------->




             
             <div class="card p-3 shadow">
            <!-- <div class="card-header">
                <h4 class="card-title">Add</h4>
            </div> -->
        <div class="card-body">
            <div class="row g-3">

            <div class="col-md-3 col-12 position-relative">
                <label for="visitorfrmname" class="form-label">Visitor Firm Name</label>
                <input class="form-control" type="text" v-model="visitor.firmname"
                    @input="filterFirmNames" @focus="showSuggestions = true" @blur="hideSuggestions" placeholder="Type Here..." 
                    autocomplete="off" />
                <ul v-if="showSuggestions && filteredFirmNames.length"
                    class="list-group position-absolute w-100" style="z-index: 1000;">
                    <li v-for="(item, index) in filteredFirmNames" :key="index"
                        class="list-group-item list-group-item-action"
                        @mousedown.prevent="selectFirmName(item.firmname)">
                        {{ item.firmname }}
                    </li>
                </ul>
            </div>

            <div class="col-md-3 col-12 position-relative">
                <label class="form-label">Visit Purpose</label>
                <input class="form-control" type="text"
                    @input="visitor.purpose = visitor.purpose.charAt(0).toUpperCase() + visitor.purpose.slice(1)"
                    v-model="visitor.purpose" placeholder="Type Here..." required>
            </div>

            <div class="col-md-3 col-12 position-relative">
                <label class="form-label">Visitor Address</label>
                <input class="form-control" type="text"
                    @input="visitor.address = visitor.address.charAt(0).toUpperCase() + visitor.address.slice(1)"
                    v-model="visitor.address" placeholder="Type Here..." required>
            </div>

            <div class="col-md-3 col-12 position-relative">
                <label class="form-label">Schedule Date</label>
                <input class="form-control" type="date" v-model="visitor.schedule_date"
                    placeholder="Type Here..." required>
            </div>

            <!-- Visitor Rows -->
            <div class="row  g-3 mt-0" v-for="(visitor_row_here, index) in visitors" :key="index">

                <div class="col-md-2 col-12 position-relative">
                    <label class="form-label">Accessories</label>
                    <input class="form-control" type="text" 
                        v-model="visitor_row_here.accessories" placeholder="Type Here..." required>
                </div>
              
                <div class="col-md-3 col-12 position-relative">
                    <label class="form-label">Name</label>
                    <input class="form-control" type="text" v-model="visitor_row_here.name"  placeholder="Type Here..."
                        @input="_filterVisitorNames(visitor_row_here)" @focus="typing_input(index)"
                        @blur="hidenameSuggestions" autocomplete="off" :readonly="visitor_row_here.isSelected"/>
                    
                    <ul v-if="shownameSuggestions && filteredVisitorNames.length && index == current_typing_visitor_count"
                        class="list-group position-absolute w-100" style="z-index: 1000;">
                        <li v-for="(item, index) in filteredVisitorNames" :key="index"
                            class="list-group-item list-group-item-action"
                            @mousedown.prevent="selectName(item.name, visitor_row_here)">
                            {{ item.name }} / {{item.contact}}
                        </li>
                    </ul>
                </div>

                <div class="col-md-3 col-12 position-relative">
                    <label class="form-label"> Contact</label>
                    <input class="form-control" type="number" @input="acceptNumber(visitor_row_here)"
                        v-model="visitor_row_here.contact"  
                        placeholder="Type Here..." required :readonly="visitor_row_here.isSelected">
                        <span class="text-danger" ref="visitor_row_here.contact"></span>
                </div>

                <div class="col-md-2 col-12 position-relative">
                    <label class="form-label">Designation</label>
                    <input class="form-control" type="text"  :readonly="visitor_row_here.isSelected"
                        v-model="visitor_row_here.designation" placeholder="Type Here..." required>
                </div>
                 <div class="col-md-1 col-12 position-relative mt-4">
                <!-- <button class="btn-primary" @click="openModel">Add</button> -->
                <!-- <img :src="visitor_row_here.photo ? visitor_row_here.photo : getUserImage()"  @click="openModel(visitor_row_here)" alt="User Image" style="height: 50px; width: 50px;"  /> -->
                  <img :src="getUserImage(visitor_row_here)"  @click="openModel(visitor_row_here)" alt="User Image" style="height: 50px; width: 50px;"  />
                </div>
                <div class="col-md-1 mt-3 d-flex justify-content-center align-items-center">
                    <button type="button" @click="addVisitor" class="btn btn-primary btn-sm p-1">
                        <i class="icofont icofont-plus-square"></i>
                    </button>&nbsp;&nbsp;
                    <button v-if="index > 0" type="button" @click="removeVisitor"
                        class="btn btn-danger btn-sm p-1">
                        <i class="icofont icofont-trash"></i>
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="card-footer text-end">
        <button class="btn btn-primary" @click="save_visitor(0)">Save Data</button>
        <!-- <button class="btn btn-primary" @click="save_visitor(1)">Save And Print</button> -->
    </div>
</div>























              <!-- end---------------------------------------------------------------------------------->











                </div>
            </div>
        </div>
    </div>


<!-- model -->
<!-- Modal Trigger Button -->
<div>
    <!-- <button class="btn btn-primary" @click="openModel">Open Modal</button> -->

    <!-- Modal -->
    <div class="modal" v-if="showModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Capture The Image</h5>
            <button type="button" class="close" @click="closeModel" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 row">
                <div class="col-6">
            <video ref="video" autoplay playsinline width="100%" height="auto"></video>
            <canvas ref="canvas" style="display: none;"></canvas>
           </div>
           <div class="col-6">
            <div v-if="capturedImage" class="mt-2">
              <p>Captured Image:</p>
              <img :src="capturedImage" alt="Captured" class="img-fluid" />
            </div>
            </div>
            <button class="btn btn-sm btn-secondary mt-2" @click="captureImage">Capture</button>
          
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-primary" @click="savechanges">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
 <!-- model -->









</template>


<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import axios from 'axios';
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getBasics();
        

    }, data() {
        return {
            showModel:false,
            capturedImage: null,

            filteredFirmNames:[],
            filteredNames:[],

            // accessories:{
            //     gatepassid:'',
            //     names: [''] // Initial empty array with one input field
            // },

            visitors: [
                    {
                        name: '',
                        contact: '',
                        designation: '',
                        accessories:''
                    }
                ],

            visitor: { "name": '', "firmname": '', "contact": '', "address": '', "purpose": '', 'designation': '', 'schedule_date': this.todayDate() },

            showModal:false,
            current_visitor_row_here:[],
            filteredVisitorNames:[],
           

                showSuggestions: false,
                hidedocSuggestions: false,
                showSuggestionsvisitname: false,
                shownameSuggestions: false,
            


        }
    },
    methods: {

        getBasics() {
            var self = this;
            axios.post('getsecurity').then(function (response) {
                self.gatepass = response.data.gatepass;
                self.visitorfirmname = response.data.visitorfirmname;
                self.visitorname = response.data.visitorname;
                self.filtered_visitorfirmname=self.visitorname;
                self.documentlist = response.data.documentlist;
   
                window.scrollTo(0, 0);
            }).then(() => {
                $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
            });


        },
 



            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },




            filterNames(visitor_row_here) {

                if (this.visitor.name.length > 0) {

                    this.visitor.name = this.visitor.name.charAt(0).toUpperCase() + this.visitor.name.slice(1);
                }

                const search = this.visitor.name.toLowerCase();




                
                this.filteredNames = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(search)
                );
                if(this.filteredNames.length>0)
                    this.showSuggestionsvisitname = true;
                else
                    this.showSuggestionsvisitname = false;


                },

                selectName(name, current_visitor) {
                current_visitor.name = name;
                let selected_visitor_row = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(name.toLowerCase())
                );
               // console.log(selected_visitor_row);
                if (selected_visitor_row.length > 0) {
                    current_visitor.contact = selected_visitor_row[0].contact;
                    current_visitor.designation = selected_visitor_row[0].designation;
                    this.visitor.address = selected_visitor_row[0].address;
                    this.visitor.firmname = selected_visitor_row[0].firmname;
                    current_visitor.photo = selected_visitor_row[0].photo;
                    // current_visitor.accessories = selected_visitor_row[0].accessories;
                }


                this.Visitor2ContactReadonly=true;
                this.VisitorDesignationReadonly=true;
                
                current_visitor.isSelected = true; // Set to true to make input readonly


                this.shownameSuggestions = false;
            },

            hidenameSuggestions() {
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.shownameSuggestions = false;
                }, 100);
            },


            _filterVisitorNames(visitor_row_here) {
                const search = visitor_row_here.name.toLowerCase();

                 


                

                this.filteredVisitorNames = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(search)
                );
                
                if(this.filteredVisitorNames && this.filteredVisitorNames.length >0)
                 this.showSuggestionsvisitname = true;
                else
                 this.showSuggestionsvisitname = false;
                 
                
                
            },
            selectVisitorName(item) {
               
                this.workpermit.name = item.name;
                this.workpermit.companyname = item.firmname;
                this.workpermit.address = item.address;
                this.workpermit.contact = item.contact;
                this.workpermit.designation = item.designation;
                this.workpermit.purpose = item.purpose;
           
                this.showSuggestionsvisitname = false;
                this.companyNameReadonly = true; // make it readonly after selecting
                this.VisitorAddressReadonly=true;
                this.VisitorContactReadonly=true;
                this.VisitorDesignationReadonly=true;

            },
            hidevisitnameSuggestions() {
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.showSuggestionsvisitname = false;
                }, 100);
            },

            // 2nd

            // filterDocumentNames(current_row) {
            //     const search = current_row.documentid.toLowerCase();
                
            //     // Filter documents based on search
            //     current_row.filtereddocuments = this.documentlist.filter(item =>
            //         item.name.toLowerCase().includes(search)
            //     );

            //     current_row.showdocSuggestions = true;
            // },

            // selectdocumentName(name, current_row) {

            //     current_row.documentid = name;

            //     current_row.showdocSuggestions = false;
            // },
            

            // hidedocSuggestions(current_row) {
            //     setTimeout(() => {
            //         current_row.showdocSuggestions = false;
            //     }, 100);
            // },



            addVisitor() {

                var self=this;

                const lastVisitor = this.visitors[this.visitors.length - 1];

                if (lastVisitor) {
                    if (String(lastVisitor.accessories).trim() === "") {
                      //  alert("Please fill in the Accessories field.");
                      self.$swal("Please fill in the Accessories field.");
                        return;
                    }
                    if (String(lastVisitor.name).trim() === "") {
                      //  alert("Please fill in the Name field.");
                        self.$swal("Please fill in the Name field.");
                        return;
                    }
                    if (String(lastVisitor.contact).trim() === "") {
                       // alert("Please fill in the Contact field.");
                        self.$swal("Please fill in the Contact field.");
                        return;
                    }
                    if (String(lastVisitor.designation).trim() === "") {
                     //   alert("Please fill in the Designation field.");
                        self.$swal("Please fill in the Designation field.");
                        return;
                    }
                    if (!lastVisitor.photo) {
                        self.$swal("Please upload a Photo.");
                        return;
                    }
                   
                }



        this.visitors.push({
            name: "",
            contact: "",
            designation: "",
            accessories:"",
            isSelected: false // New row, editable by default
        });
        //   this.$nextTick(() => {
        //     this.initializeSelect2(); // re-init Select2 on new elements
        // });


    //    this.onlyvisitorname=false;


        },
    // addDocuments() {


    // const last = this.workpermits[this.workpermits.length - 1];

    //     if (last && (last.documentpath === "" || last.documentid === "")) {
    //         alert("Please fill out the previous document before adding a new one.");
    //         return;
    //     }


    // this.workpermits.push({
    //     documentpath: "",
    //     documentid: "",
    //     expirydate: "",
    // });
    // },




removeVisitor(index) {
                this.visitors.splice(index, 1);
            },
            removeDocuments(index) {
                this.workpermits.splice(index, 1);
            },

            acceptNumber(visitor_row_here) {
                // only keep numbers
                visitor_row_here.contact = (visitor_row_here.contact+"").replace(/\D/g, "");
                // if(visitor_row_here.contact.length>10)
                //      this.$refs[visitor_row_here.contact].textContent="Invalid";
                // this.visitors[index].contact = value;
            },


            typing_input(_index) {
                this.shownameSuggestions = true;
                this.current_typing_visitor_count = _index;
                // alert(this.current_typing_visitor_count);
            },


            openModel(visitor_row_here) {
                this.current_visitor_row_here=visitor_row_here;

            this.showModel = true;
            this.startWebcam();
            },

            closeModel() {
            this.showModel = false;
            this.stopWebcam();
            },
            
            startWebcam() {
            if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
                navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    const videoElement = this.$refs.video;
                    if (videoElement) {
                    videoElement.srcObject = stream;
                    videoElement.play();
                    } else {
                    console.error("Video element not found.");
                    }
                })
                .catch((err) => {
                    console.error("Error accessing webcam: ", err);
                });
            } else {
                alert("Webcam not supported in this browser.");
                console.error("navigator.mediaDevices or getUserMedia not available.");
            }
            },

        stopWebcam() {
        const video = this.$refs.video;
        const stream = video.srcObject;
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            video.srcObject = null;
        }
        },


    captureImage() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      this.capturedImage = canvas.toDataURL('image/png');
      this.current_visitor_row_here.photo=this.capturedImage;
      this.capturedImage=null;
      this.showModel = false;
      this.stopWebcam();
    },


//     getUserImage() {
//     return `${this.$hostname}/writable/visitors/user.png`;
//   },

    getUserImage(visitor_row_here) {
    // Check if the visitor has a photo
    if (visitor_row_here && visitor_row_here.photo) {
        return `${this.$hostname}/writable/visitors/${visitor_row_here.photo}`;
    }
    // If no photo exists, return a default placeholder image
    return `${this.$hostname}/writable/visitors/user.png`;
    },


  savechanges(){
    this.showModel=false;
  },

 // for firm name--------------------------------------------------------
 filterFirmNames() {
                const search = this.visitor.firmname.toLowerCase();
                //   if(search=='')
                //     this.showSuggestions = false;
                //   else

                if (this.visitor.firmname.length > 0) {
                    this.visitor.firmname = this.visitor.firmname.charAt(0).toUpperCase() + this.visitor.firmname.slice(1);
                }


                this.showSuggestions = true;
                this.filteredFirmNames = this.visitorfirmname.filter(item =>
                    item.firmname.toLowerCase().includes(search)
                );
            },
            selectFirmName(name) {


                // axios.post('filternamebyfirm', { filter: name })
                //     .then(response => {
                //         var msg = '';
                //         self.visitorname = response.data.visitorname;

                //     })
                //     .catch(error => {
                //         console.log('Error on Authentication: ' + error);
                //     });





                this.filteredNames = this.visitorname.filter(item =>
                    item.firmname.toLowerCase().includes(name)
                );




                this.visitor.firmname = name;
                this.showSuggestions = false;
            },
            hideSuggestions() {
                //alert("hello");
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.showSuggestions = false;
                }, 100);
            },
            //for firm name-------------------------------------------------------------------

 // for visitor name-------------------------------------------------------------------------------------------------
            // filterNames(visitor_row_here) {

            // if (this.visitor.name.length > 0) {

            //     this.visitor.name = this.visitor.name.charAt(0).toUpperCase() + this.visitor.name.slice(1);
            // }

            // const search = this.visitor.name.toLowerCase();




            // this.shownameSuggestions = true;
            // this.filteredNames = this.visitorname.filter(item =>
            //     item.name.toLowerCase().includes(search)
            // );

            // this.showSuggestionsvisitname = false;


            // },
            
            // selectName(name, current_visitor) {
            // current_visitor.name = name;
            // let selected_visitor_row = this.visitorname.filter(item =>
            //     item.name.toLowerCase().includes(name.toLowerCase())
            // );
            // console.log(selected_visitor_row);
            // if (selected_visitor_row.length > 0) {
            //     current_visitor.contact = selected_visitor_row[0].contact;
            //     current_visitor.designation = selected_visitor_row[0].designation;
            // }


            // this.Visitor2ContactReadonly=true;
            // this.VisitorDesignationReadonly=true;

            // this.shownameSuggestions = false;
            // },
            hidenameSuggestions() {
            // Add delay so click registers before hiding
            setTimeout(() => {
                this.shownameSuggestions = false;
            }, 100);
            },


// for visitor name-------------------------------------------------------------------------------------------------


save_visitor() {
                var self = this;

                if(self.visitor.firmname == ''){
                    self.$swal("Enter Firm Name");
                }else if(self.visitor.address == ''){
                    self.$swal("Enter Address");
                }else{

                const formData = new FormData();

                


                    self.visitors.forEach((visitor, index) => {




                        if(visitor.photo){

   
                            formData.append(`visitor_accessories[]`, visitor.accessories);
                       
                            formData.append(`visitor_name[]`, visitor.name);
                           formData.append(`visitor_contact[]`, visitor.contact);
                           formData.append(`visitor_designation[]`, visitor.designation);
                           formData.append(`photo_${index}` , `visitor_${index}.png`);


                        }else{

                            if (visitor.photo && visitor.photo.startsWith('data:image')) {
                             const blob = this.dataURLtoBlob(visitor.photo);
                             visitor.photo='';

                             
                            
                             formData.append(`visitor_accessories[]`, visitor.accessories);
                       
                             formData.append(`visitor_name[]`, visitor.name);
                             formData.append(`visitor_contact[]`, visitor.contact);
                             formData.append(`visitor_designation[]`, visitor.designation);
                             formData.append(`photo_${index}`, blob , `visitor_${index}.png`);
                           // formData.append(`photo`, blob, `visitor_${index}.png`);
                        }

                        }
                  
                       
                       
                   
                    });
                    

                    // self.visitors.forEach((visitor, index) => {
                    //             formData.append(`visitors[${index}][accessories]`, visitor.accessories);
                    //             formData.append(`visitors[${index}][name]`, visitor.name);
                    //             formData.append(`visitors[${index}][contact]`, visitor.contact);
                    //             formData.append(`visitors[${index}][designation]`, visitor.designation);
                                
                    //             // Handle photo if it exists
                    //             if (visitor.photo && visitor.photo.startsWith('data:image')) {
                    //                 const blob = this.dataURLtoBlob(visitor.photo);
                    //                 formData.append(`visitors[${index}][photo]`, blob, `visitor_${index}.png`);
                    //             }
                    //         });




                // formData.append('name', self.visitor.name);
                formData.append('firmname', self.visitor.firmname);
                // formData.append('contact', self.visitor.contact); 
                formData.append('purpose', self.visitor.purpose);
                formData.append('schedule_date', self.visitor.schedule_date);
                formData.append('address', self.visitor.address);
                // formData.append('designation', self.visitor.designation); 



                axios.post('createGatePasssecurity', formData,{
                      headers: {
                        'Content-Type': 'multipart/form-data',
                      },
                    })
                    .then(response => {
                        var msg = '';
                        var gatepass_success = response.data.gatepass_success;
                        var visitor_success = response.data.visitor_success;

                        msg = response.data.visitor_statusmsg;
                        if (gatepass_success)
                            msg = response.data.gatepass_statusmsg;
                       // self.visitor = { "name": '', "firmname": '', "contact": '', "purpose": '', 'schedule_date': new Date().toLocaleString() };

                        self.gatepass = response.data.gatepass;
                        // if (print == 1)
                            window.open(window.location.origin + "/printpass?q=" + response.data.inserted_gatepass, '_blank');
                        // else {
                        //     self.$swal(msg);
                        //     if (gatepass_success == 1) {
                        //         $("#gatepassAdd").modal("toggle");
                        //         self.$emit('getGatePassData', self.gatepass);
                        //       //  self.visitor = { "name": '', "firmname": '', "contact": '', "purpose": '', 'schedule_date': new Date().toLocaleString() };
                        //     }
                        // }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }

            },


        // Converts base64 to Blob (binary)
        // base64ToBlob(base64, contentType = '') {
        //     const byteCharacters = atob(base64);
        //     const byteNumbers = new Array(byteCharacters.length);
        //     for (let i = 0; i < byteCharacters.length; i++) {
        //         byteNumbers[i] = byteCharacters.charCodeAt(i);
        //     }
        //     const byteArray = new Uint8Array(byteNumbers);
        //     return new Blob([byteArray], { type: contentType });
        // },

        base64ToBlob(base64, contentType = '') {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        },

         dataURLtoBlob(dataURL) {
          const byteString = atob(dataURL.split(',')[1]);
          const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ab], { type: mimeString });
        },




          
    }
}
</script>
<style scoped>
.modal {
  z-index: 1050;
}
</style>